import React from "react";

import { JOB_REASON_DESCRIPTIONS } from "../constants";
import {
  FailureCode,
  FailureHeading,
  FailureMessage,
  FailureSection,
  FailureText,
} from "../styles";
import { JobFailureProps } from "../types";

export const JobFailure: React.FC<JobFailureProps> = ({
  job: { reason, lastError },
}) => {
  const hasFailure = reason !== null || lastError !== null;

  return (
    <FailureSection>
      <FailureHeading>Failure</FailureHeading>
      {reason && (
        <>
          <FailureText>{JOB_REASON_DESCRIPTIONS[reason]}</FailureText>
          <FailureCode>{reason}</FailureCode>
        </>
      )}
      {lastError && <FailureMessage>{lastError}</FailureMessage>}
      {!hasFailure && <FailureText>No failure recorded</FailureText>}
    </FailureSection>
  );
};
